<p-blockUI [blocked]="loading || isDirectApplyLoading">
  <div class="block-ui-overlay">
    <i class="pi pi-spinner pi-spin block-ui-spinner"></i>
  </div>
</p-blockUI>

<div class="da-header-section">
  <h1>You're one step from your dream campuses.</h1>
  <div class="subtext">
    <ng-container *ngIf="!isDirectApplyLoading && directApplyColleges.length > 0">
      {{ selectedSlots }} of your {{ totalSlots }} college slot{{ selectedSlots !== 1 ? 's are' : ' is' }} ready to
      ship. Review your picks, then lock in your applications —
      most students complete this in under 2 minutes.
    </ng-container>
    <ng-container *ngIf="isDirectApplyLoading">
      Loading your college list...
    </ng-container>
    <ng-container *ngIf="!isDirectApplyLoading && directApplyColleges.length === 0">
      You haven't added any colleges to Direct Apply yet. Browse and add colleges to get started.
    </ng-container>
  </div>
</div>

<div class="da-main-layout">
  <div class="main-column">
    <div class="section-header">
      <div class="section-title-uppercase">YOUR COLLEGES</div>
      <div class="slots-badge">{{ selectedSlots }} of {{ totalSlots }} selected · {{ freeSlots }} slot{{ freeSlots !== 1
        ? 's' : '' }} free</div>
    </div>

    <!-- Loading state -->
    <div *ngIf="isDirectApplyLoading" style="display:flex;justify-content:center;padding:32px 0;">
      <div style="display:flex;flex-direction:column;align-items:center;gap:12px;color:#666;">
        <div
          style="width:36px;height:36px;border:3px solid #cdd22d;border-top-color:#000086;border-radius:50%;animation:spin 0.8s linear infinite;">
        </div>
        <span style="font-size:14px;">Loading your colleges...</span>
      </div>
    </div>

    <!-- Dynamic college cards from API -->
    <div class="da-card college-card" *ngFor="let college of directApplyColleges; let i = index">
      <div class="left-side">
        <div class="icon">
          <img *ngIf="college.logo" [src]="college.logo" [alt]="college.instituteName + ' Logo'"
            style="width:100%;height:100%;object-fit:contain;border-radius:6px;">
          <i *ngIf="!college.logo" class="pi pi-building"></i>
        </div>
        <div class="details">
          <div class="name">
            {{ college.instituteName }}
            <i class="pi pi-check"
              style="color:#ffffff;font-size:11px;border-radius:12rem;background-color:#2e7d32;padding:4px;margin-bottom:6px;">
            </i>
          </div>
          <div class="program">{{ college.courseName || 'N/A' }}</div>
          <div class="tags">
            <span class="green" *ngIf="college.inTakeYear">Intake: {{ college.inTakeYear }}</span>
            <span class="orange" *ngIf="college.mentorDeadline">Deadline: {{ college.mentorDeadline }}</span>
          </div>
        </div>
      </div>

      <div class="right-side">
        <button class="remove-btn" (click)="removeDirectApply(i)" title="Remove">
          <i class="pi pi-times"></i>
        </button>
        <div class="da-badge">DA</div>
      </div>
    </div>

    <!-- Empty state when no colleges and not loading -->
    <div *ngIf="!isDirectApplyLoading && directApplyColleges.length === 0"
      style="text-align:center;padding:40px 20px;color:#666;">
      <i class="pi pi-inbox" style="font-size:48px;color:#cdd22d;margin-bottom:16px;display:block;"></i>
      <h3 style="margin:0 0 8px;color:#000086;">No colleges added yet</h3>
      <p style="margin:0 0 20px;font-size:14px;">Add colleges from the institute search to see them here.</p>
      <button class="btn-outline" (click)="browseColleges()">Browse Colleges <i class="pi pi-arrow-right"></i></button>
    </div>

    <!-- Add a college card -->
    <div class="da-card add-college-card" *ngIf="freeSlots > 0">
      <div class="left-side">
        <div class="icon"><i class="pi pi-plus"></i></div>
        <div class="details">
          <div class="name">Add a college</div>
          <div class="sub">{{ freeSlots }} slot{{ freeSlots !== 1 ? 's' : '' }} remaining — same flat platform fee</div>
        </div>
      </div>
      <button class="btn-outline btn-medium" (click)="browseColleges()">Browse <i
          class="pi pi-arrow-right"></i></button>
    </div>

    <div class="tip-banner" *ngIf="freeSlots > 0">
      <i class="pi pi-bolt"></i> Disclaimer: This fee covers GP Direct Apply platform processing only. University application fees, if applicable, will be charged separately.
    </div>

    <div class="cta-banner">
      <div class="left-content">
        <div class="img-wrapper">
          <img src="assets/icons/review_icon.png" alt="Illustration">
        </div>
        <div class="text">
          <h3>Not sure about your shortlist?</h3>
          <p>Get a free 1:1 profile review before you pay. Priya has guided 1,200+ students into top-30 programs, she'll
            tell you exactly where you stand.</p>
        </div>
      </div>
      <button class="btn-yellow" (click)="showClarityPopup = true">Book My Clarity Call</button>
    </div>
  </div>

  <div class="right-column">
    <div class="sticky-panel">
      <div class="da-card order-summary">
        <div class="title">Order Summary</div>
        <div class="summary-subtitle">You're paying only the GP Direct application  fee. University  Application fee is paid separately later.</div>

        <!-- Dynamic per-college rows -->
        <ng-container *ngIf="!isDirectApplyLoading">
          <div class="item-row" *ngFor="let college of directApplyColleges">
            <div class="label">
              {{ college.instituteName }}
              <span class="sub">Processing fee</span>
            </div>

            <div class="value">₹{{ packageDetails?.amount || 1000 }}</div>
          </div>
          <div class="item-row" *ngIf="directApplyColleges.length === 0" style="color:#999;font-size:14px;">
            No colleges selected yet.
          </div>
        </ng-container>

        <!-- Loading skeleton -->
        <ng-container *ngIf="isDirectApplyLoading">
          <div class="item-row" style="color:#aaa;font-size:14px;">Loading...</div>
        </ng-container>

        <div class="divider"></div>

        <div class="item-row">
          <div class="label">GradPilots Platform Fee</div>
          <div class="value">₹{{ baseAmount }}</div>
        </div>
        <div class="item-row">
          <div class="label">GST (18%)</div>
          <div class="value">₹{{ gstAmount }}</div>
        </div>

        <div class="discount-row">
          <div style="display: flex; align-items: center; gap: 8px;">
            <i class="pi pi-gift" style="color: #f57f17;"></i> Profile review included
          </div>
          <div class="strike">₹3,000</div>
        </div>

        <div class="divider"></div>

        <div class="total-row">
          <div class="label">Total payable <span class="sub">incl. all taxes &amp; fees</span></div>
          <div class="value">₹{{ totalAmount }}</div>
        </div>
        <button pButton class="payment-btn" (click)="processPayment()"
          [disabled]="loading || isDirectApplyLoading || directApplyColleges.length === 0 || paymentInProgress"
          [loading]="paymentInProgress" icon="pi pi-arrow-right" iconPos="right" label="Continue to Payment"
          style="width: 100%; border-radius: 8px; padding: 12px; font-weight: 600; display: flex; justify-content: center; align-items: center; gap: 8px; background-color: #000086; color: white; border: none; cursor: pointer;">
        </button>
        <p-toast></p-toast>
      </div>
    </div>
  </div>
</div>

<app-clarity-call-popup
  [(visible)]="showClarityPopup"
  [contactPurpose]="ContactPurpose.DirectApplyContactUs"
  headline="Confused about your application process?<br>Let's sort it."
  bodyText="You don't have to figure out your application alone. Whether it's choosing universities, picking an apply option, or getting through the form — drop it here and we'll help you move forward."
  inputPlaceholder="Stuck on a step? Tell us here"
  ctaLabel="Get help">
</app-clarity-call-popup>
<style>
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
</style>